export default __webpack_public_path__ + "static/media/Zone-Master-Plan-Type-H.1e77bb20.png";